import { render, staticRenderFns } from "./SearchResultsWrapper.vue?vue&type=template&id=3d7822f8&"
import script from "./SearchResultsWrapper.vue?vue&type=script&lang=js&"
export * from "./SearchResultsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports